import { useEffect, type RefObject } from 'react';

/** Helpers of {@link FloatingList} for the fields that open it. */

/** Calls `onOutside` for a mouse press outside the field and outside its list. */
export function useOutsidePress(
  open: boolean,
  refs: RefObject<HTMLElement | null>[],
  onOutside: () => void,
) {
  useEffect(() => {
    if (!open) return;
    const handler = (e: MouseEvent) => {
      const target = e.target as Node;
      if (!refs.some((r) => r.current?.contains(target))) onOutside();
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open, refs, onOutside]);
}

/** Text as compared when filtering: trimmed, inner spaces collapsed, case ignored. */
export function normalizeText(text: string): string {
  return text.trim().replace(/\s+/g, ' ').toLowerCase();
}

/** Keeps the highlighted entry in view while moving with the arrow keys. */
export function scrollEntryIntoView(listId: string, index: number) {
  document
    .getElementById(`${listId}-opt-${index}`)
    ?.scrollIntoView({ block: 'nearest' });
}
